import { Avatar, IconButton, Menu, styled, Tooltip } from '@mui/material';
import { useState } from 'react';
import { FluxNestedMenu } from './FluxNestedMenu';

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  '&:hover': {
    backgroundColor: 'white',
  },
}));

interface MenuItemType {
  Icon?: React.ReactNode;
  label: string;
  onMenuItemClick?: () => void;
  subItems?: MenuItemType[];
}

interface FluxIconMenuProps {
  tooltip: string;
  width?: number;
  height?: number;
  menuList: MenuItemType[];
  CustomAvatar?: React.ReactNode;
  footer?: React.ReactNode;
}

export const FluxIconMenu: React.FC<FluxIconMenuProps> = ({ tooltip, width, height, menuList, CustomAvatar, footer }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? `${tooltip}-menu` : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          sx={{
            '&:hover': {
              color: 'white',
            },
            fontSize: width || height || 20,
          }}
        >
          {CustomAvatar ? (
            <StyledAvatar sx={{ width: width || 20, height: height || 20 }}>{CustomAvatar}</StyledAvatar>
          ) : (
            <StyledAvatar sx={{ width: width || 20, height: height || 20 }} />
          )}
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id={`${tooltip}-menu`}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              minWidth: 200,
              '& .MuiAvatar-root': {
                ml: -0.5,
                mr: 1,
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <FluxNestedMenu items={menuList} onItemClick={handleClose} />
        {footer}
      </Menu>
    </>
  );
};
